import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    items: [],
    quantities: {},
    expandedCategory: null,
    expandedSubcategory: null,
    images: null,
    loading: false
};

const cartSlice = createSlice({
    name: 'cart',
    initialState,
    reducers: {
        addToCart: (state, action) => {
            const { name, quantity } = action.payload;
            const existingItem = state.items.find(item => item.name === name);

            if (existingItem) {
                existingItem.quantity += quantity;
            } else {
                state.items.push({ name, quantity });
            }
        },
        removeFromCart: (state, action) => {
            state.items = state.items.filter(item => item.name !== action.payload);
        },
        setQuantity: (state, action) => {
            const { name, value } = action.payload;
            state.quantities[name] = value;
        },
        toggleCategory: (state, action) => {
            state.expandedCategory =
                state.expandedCategory === action.payload ? null : action.payload;
        },
        toggleSubcategory: (state, action) => {
            state.expandedSubcategory =
                state.expandedSubcategory === action.payload ? null : action.payload;
        },
        setImages: (state, action) => {
            state.images = action.payload;
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        clearCart: (state) => {
            state.items = [];
            state.quantities = {};
        }
    }
});

export const {
    addToCart,
    removeFromCart,
    setQuantity,
    toggleCategory,
    toggleSubcategory,
    setImages,
    setLoading,
    clearCart
} = cartSlice.actions;

export default cartSlice.reducer;